module.exports = __webpack_public_path__ + "static/img/Group 21.59d36537.svg";